import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

export const Header: React.FunctionComponent<BoxProps> = props => {
  return <Box use="header" css={{ flexShrink: 0 }} {...props} />;
};

export default Header;
